import { QRAssign } from "../Constants/QRCodesToAssign";

export const getQRCodesNotmapped = (qrCodestoassign) => {
    return {
        type: QRAssign.GET_QRCODESNOTMAPPED,
        payload: qrCodestoassign
    };
};
